module.exports = __webpack_public_path__ + "img/list_hk1_1_zh.a3856478.png";